import { AbstractQuestionWithMultipleOption } from '../abstract-question-multiple-option.store';

export const MultipleAnswerQuestion = AbstractQuestionWithMultipleOption.named(
  'MultipleAnswerQuestion'
);
